import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Col,
  Row,
  Form,
  Modal,
  ListGroup,
} from "react-bootstrap"; // Importez Form pour le champ de saisie
import {
  FaCheck,
  FaDownload,
  FaRegTimesCircle,
  FaPaperclip,
} from "react-icons/fa";
import moment from "moment";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import {
  assignProcedure,
  closeProcedure,
  rejectProcedure,
} from "../../../redux/actions/ProcedureActions";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../components/loader/Loader";
import { updateBusinessRequest } from "../../../redux/actions/RequestActions";
import countries from "i18n-iso-countries";
import fr from "i18n-iso-countries/langs/fr.json";
import { useReactToPrint } from "react-to-print";
import PrintCreationProcedure from "../../../components/print/PrintCreationProcedure";
import {
  getBusinessCreationRequestDocuments,
  uploadCompanyGeneralDocuments,
} from "../../../redux/actions/DocumentActions";
import { FiArrowLeft, FiFile } from "react-icons/fi";
import { getCompanyByRequest } from "../../../redux/actions/CompanyActions";
import { StatusBadge } from "../../../components/dashboard/DashboardUI";
import {
  procedureLabel,
  requestTitle,
  serviceLabel,
} from "../../../utils/requestDisplay";
import { isAssociation } from "../../../utils/creationFlow";
import { seatAddress } from "../../../utils/regions";

countries.registerLocale(fr);

function BusinessCreationDetails() {
  const location = useLocation();
  const navigate = useNavigate();
  const { businessCreation } = location.state || {};
  const dispatch = useDispatch();
  const [submitting, setSubmitting] = useState(false);
  const [newBusinessName, setNewBusinessName] = useState(
    businessCreation.businessName || "",
  );
  const { token } = useSelector((state) => state.authUser.user);
  const contentRef = useRef();
  const handlePrint = useReactToPrint({
    contentRef,
  });

  const [formData, setFormData] = useState({ comment: "" });
  const [showModal, setShowModal] = useState(false);
  const [action, setAction] = useState("");
  const handleModalClose = () => setShowModal(false);
  const handleModalShow = (action) => {
    setAction(action);
    setShowModal(true);
  };
  const { user } = useSelector((state) => state.authUser);
  const [loading, setLoading] = useState(true);
  const [documents, setDocuments] = useState(null);
  const [attachment, setAttachment] = useState(null);
  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 4000,
  });

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setAttachment(file);
  };

  useEffect(() => {
    const fetchDocuments = async () => {
      if (businessCreation && user?.token && businessCreation?.reference) {
        setLoading(true);
        try {
          await dispatch(
            getBusinessCreationRequestDocuments(
              user.token,
              businessCreation.reference,
              (data) => {
                if (data) {
                  setDocuments(data);
                }
              },
            ),
          );
        } catch (error) {
          console.error("Erreur lors du chargement des documents :", error);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchDocuments();
  }, [businessCreation, user?.token, dispatch]);

  const association = isAssociation(businessCreation?.businessType);

  const handleAction = (action) => {
    Swal.fire({
      title: `Voulez-vous vraiment ${
        action === "in_progress"
          ? "traiter"
          : action === "fulfilled"
            ? "clôturer"
            : action === "failed" && "rejeter"
      } cette demarche ?`,
      text: "Cette action est irréversible.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#ccc",
      confirmButtonText: "Confirmer",
      cancelButtonText: "Annuler",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setSubmitting(true);

        if (action === "in_progress") {
          dispatch(
            assignProcedure(
              token,
              { request: businessCreation?.reference },
              handleCallback,
            ),
          );
        } else if (action === "fulfilled") {
          if (attachment) {
            await dispatch(
              closeProcedure(
                token,
                {
                  request: businessCreation?.reference,
                  status: action,
                  comment: formData.comment,
                },
                handleFulfilledCallback,
              ),
            );
          }
        } else if (action === "failed") {
          dispatch(
            rejectProcedure(
              token,
              { request: businessCreation?.reference, status: action },
              handleCallback,
            ),
          );
        }
      }
    });
  };

  const handleCallback = async ({ success, message }) => {
    if (success) {
      Toast.fire({
        icon: "success",
        title: "Succès",
        text: message,
      });
      navigate(-1);
    } else {
      Toast.fire({
        icon: "error",
        title: "Échec",
        text: message,
      });
    }
    setSubmitting(false);
  };

  const handleFulfilledCallback = async ({ success, message }) => {
    if (success) {
      try {
        const formData2 = new FormData();
        formData2.append("documents", attachment);

        await dispatch(
          getCompanyByRequest(
            user.token,
            businessCreation.reference,
            ({ success, message, data }) => {
              if (success) {
                dispatch(
                  uploadCompanyGeneralDocuments(
                    user.token,
                    data._id,
                    formData2,
                    ({ success, message }) => {
                      if (success) {
                        Toast.fire({
                          icon: "success",
                          title: "Succès",
                          text: message,
                        }).then(() => {
                          setSubmitting(false);
                          navigate(-1);
                        });
                      } else {
                        Toast.fire({
                          icon: "error",
                          title: "Échec",
                          text: message,
                        });
                        setSubmitting(false);
                      }
                    },
                  ),
                );
              } else {
                Toast.fire({
                  icon: "error",
                  title: "Échec",
                  text: message,
                });
                setSubmitting(false);
              }
            },
          ),
        );

        setAttachment(null);
      } catch (error) {
        Toast.fire({
          icon: "error",
          title: "Erreur",
          text: "Échec du téléchargement du fichier.",
        });
        setSubmitting(false);
      }
    } else {
      Toast.fire({
        icon: "error",
        title: "Échec",
        text: message,
      });
      setSubmitting(false);
    }
  };

  // Fonction pour soumettre le nom de l'entreprise
  const handleSubmitBusinessName = () => {
    Swal.fire({
      title: `Voulez-vous vraiment définir "${newBusinessName}" comme le nom de cette entreprise ?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#ccc",
      confirmButtonText: "Confirmer",
      cancelButtonText: "Annuler",
    }).then((result) => {
      if (result.isConfirmed) {
        setSubmitting(true);
        dispatch(
          updateBusinessRequest(
            token,
            businessCreation?.reference,
            { businessName: newBusinessName },
            handleBusinessNameCallback,
          ),
        );
      }
    });
  };

  const handleBusinessNameCallback = ({ success, message }) => {
    if (success) {
      Toast.fire({
        icon: "success",
        title: "Succès",
        text: message,
      });
      navigate(-1);
    } else {
      Toast.fire({
        icon: "error",
        title: "Échec",
        text: message,
      });
    }
    setSubmitting(false);
  };

  const canTake = businessCreation.status === "paid" && !businessCreation.operator;
  const canClose =
    businessCreation.status === "in_progress" &&
    businessCreation.operator &&
    businessCreation.businessName;

  return (
    <>
      <Loader isLoading={submitting} />
      {loading ? (
        <p className="dash-loading">Chargement de la démarche…</p>
      ) : (
        <>
          <div className="dash-page-header">
            <div>
              <button
                type="button"
                className="dash-back"
                onClick={() => navigate(-1)}
              >
                <FiArrowLeft aria-hidden="true" /> Démarches clients
              </button>
              <h1 className="dash-page-title">
                {requestTitle(businessCreation)}
              </h1>
              <p className="dash-page-lead">
                #{businessCreation.reference} ·{" "}
                {moment(businessCreation.createdAt).format("DD/MM/YYYY")}
              </p>
            </div>
            <div className="dash-header-actions">
              <StatusBadge status={businessCreation.status} />
              {canTake && (
                <button
                  type="button"
                  className="dash-button"
                  onClick={() => handleAction("in_progress")}
                >
                  Prendre en charge
                </button>
              )}
              {canClose && (
                <>
                  <button
                    type="button"
                    className="dash-button is-secondary"
                    onClick={handlePrint}
                  >
                    Imprimer
                  </button>
                  <button
                    type="button"
                    className="dash-button"
                    onClick={() => handleModalShow("fulfilled")}
                  >
                    Clôturer
                  </button>
                </>
              )}
            </div>
          </div>

          <div className="dash-card dash-legacy-body">
              <div className="mb-4">
                  <h6 className="fw-bold">Informations de la démarche</h6>
                  {procedureLabel(businessCreation) && (
                    <p className="mb-1">
                      <span style={{ fontWeight: 500 }}>
                        {association ? "Délai" : "Procédure"} :
                      </span>{" "}
                      {procedureLabel(businessCreation)}
                    </p>
                  )}
                  {!businessCreation.procedure && businessCreation.deadline && (
                    <p className="mb-1">
                      <span style={{ fontWeight: 500 }}>
                        Délais de création :
                      </span>{" "}
                      {(() => {
                        const deadlines = {
                          WEEK: "Cette semaine",
                          DAYS: "Dans les jours à venir",
                          MONTHS: "Dans les mois à venir",
                        };

                        return deadlines[businessCreation.deadline] || "";
                      })()}
                    </p>
                  )}
              </div>

              <Row className="g-4">
                <Col md={6}>
                  <h6 className="fw-bold">Informations du client</h6>
                  <p className="mb-1">
                    <span style={{ fontWeight: 500 }}>Nom</span> :{" "}
                    {businessCreation.user?.firstname}{" "}
                    {businessCreation.user?.lastname}
                  </p>
                  <p className="mb-1">
                    <span style={{ fontWeight: 500 }}>Email</span> :{" "}
                    {businessCreation.user?.email}
                  </p>
                  <p className="mb-1">
                    <span style={{ fontWeight: 500 }}>Téléphone</span> :{" "}
                    {businessCreation.user?.mobile}
                  </p>
                  <p className="mb-1">
                    <span style={{ fontWeight: 500 }}>WhatsApp</span> :{" "}
                    {businessCreation.user?.whatsApp}
                  </p>
                  <p className="mb-1">
                    <span style={{ fontWeight: 500 }}>Pays de résidence</span> :{" "}
                    {countries.getName(businessCreation.user.country, "fr") ||
                      businessCreation.user.country}
                  </p>
                </Col>

                <Col className="text">
                  <h6 className="fw-bold">Informations de l'entreprise</h6>
                  <p className="mb-1">
                    <span style={{ fontWeight: 500 }}>Type d'entreprise</span> :{" "}
                    {businessCreation?.businessType}
                  </p>

                  {businessCreation?.status === "in_progress" ? (
                    <>
                      <p className="mb-1">
                        <span style={{ fontWeight: 500 }}>
                          Nom de l'entreprise :
                        </span>{" "}
                      </p>
                      <div className="d-flex align-items-center mb-1">
                        <Form.Control
                          type="text"
                          placeholder="Entrez le nom de l'entreprise"
                          value={newBusinessName}
                          onChange={(e) => setNewBusinessName(e.target.value)}
                          style={{ flex: 1 }}
                        />
                        <Button
                          variant="primary"
                          size="sm"
                          className="ms-2"
                          disabled={
                            !businessCreation.operator || !newBusinessName
                          }
                          onClick={handleSubmitBusinessName}
                        >
                          <FaCheck /> Soumettre
                        </Button>
                      </div>
                    </>
                  ) : (
                    <p className="mb-1">
                      <span style={{ fontWeight: 500 }}>
                        Nom de l'entreprise
                      </span>{" "}
                      :{" "}
                      {businessCreation?.businessName ||
                        "À fournir par Platform98"}
                    </p>
                  )}

                  {!association && (
                    <p className="mb-1">
                      <span style={{ fontWeight: 500 }}>
                        Secteur d'activité :
                      </span>{" "}
                      {(() => {
                        const activitySectors = {
                          COM: "Commerce général",
                          BTP: "BTP",
                          INF: "Services informatique",
                          RES: "Restauration",
                          IMM: "Activités immobilières (SCI)",
                          VTC: "Transport VTC",
                          ARG: "Agence de transfert d’argent",
                          VOY: "Agence de voyage",
                          ENT: "Services aux entreprises",
                          FRE: "Consultation & Freelance",
                          CAB: "Cabinet de conseil",
                          AUT: "Autre",
                        };

                        return (
                          activitySectors[businessCreation?.activitySector] ||
                          businessCreation?.activitySector ||
                          "Inconnu"
                        );
                      })()}
                    </p>
                  )}
                  {businessCreation?.shareCapital > 0 && (
                    <p className="mb-1">
                      <span style={{ fontWeight: 500 }}>Capital social :</span>{" "}
                      {businessCreation?.shareCapital}
                    </p>
                  )}
                  <p className="mb-1">
                    <span style={{ fontWeight: 500 }}>
                      {association ? "Président" : "Gérant"}
                    </span>{" "}
                    : {businessCreation?.managerName}
                  </p>
                  {businessCreation?.companyPhone && (
                    <p className="mb-1">
                      <span style={{ fontWeight: 500 }}>
                        Téléphone de l'entreprise
                      </span>{" "}
                      : {businessCreation.companyPhone}
                    </p>
                  )}
                  {businessCreation?.companyEmail && (
                    <p className="mb-1">
                      <span style={{ fontWeight: 500 }}>
                        E-mail de l'entreprise
                      </span>{" "}
                      : {businessCreation.companyEmail}
                    </p>
                  )}
                  <p className="mb-1">
                    <span style={{ fontWeight: 500 }}>Pays</span> :
                    {countries.getName(businessCreation?.country, "fr") ||
                      businessCreation?.country}
                  </p>
                  {businessCreation?.address && (
                    <p className="mb-1">
                      <span style={{ fontWeight: 500 }}>Siège social :</span>{" "}
                      {seatAddress(businessCreation)}
                    </p>
                  )}
                  {businessCreation?.bank && (
                    <p className="mb-1">
                      <span style={{ fontWeight: 500 }}>Banque</span> :{" "}
                      {businessCreation?.bank}
                    </p>
                  )}
                </Col>
              </Row>

              {businessCreation?.services.filter(
                (service) => service.code !== "registration",
              ).length > 0 && (
                <>
                  <h6 className="fw-bold mt-4">Services associés</h6>
                  <ul>
                    {businessCreation?.services
                      .filter((service) => service.code !== "registration")
                      .map((service, index) => (
                        <li key={index}>{serviceLabel(service)}</li>
                      ))}
                  </ul>
                </>
              )}

              {documents && businessCreation.operator && (
                <ListGroup className="mt-3">
                  <h6 className="fw-bold">Documents requis pour la création</h6>
                  {documents.mgId && (
                    <ListGroup.Item className="d-flex align-items-center justify-content-between">
                      <div className="d-flex align-items-center">
                        <FiFile style={{ marginRight: "5px" }} size={20} />
                        {documents.mgId.name}
                      </div>
                      <FaDownload
                        onClick={() => window.open(documents.mgId.url)}
                        style={{
                          cursor: "pointer",
                          fontSize: "20px",
                          color: "blue",
                        }}
                      />
                    </ListGroup.Item>
                  )}

                  {documents.shdIds && (
                    <ListGroup.Item className="d-flex align-items-center justify-content-between">
                      <div className="d-flex align-items-center">
                        <FiFile style={{ marginRight: "5px" }} size={20} />
                        {documents.shdIds.name}
                      </div>
                      <FaDownload
                        onClick={() => window.open(documents.shdIds.url)}
                        style={{
                          cursor: "pointer",
                          fontSize: "20px",
                          color: "blue",
                        }}
                      />
                    </ListGroup.Item>
                  )}

                  {documents.location && (
                    <ListGroup.Item className="d-flex align-items-center justify-content-between">
                      <div className="d-flex align-items-center">
                        <FiFile style={{ marginRight: "5px" }} size={20} />
                        {documents.location.name}
                      </div>
                      <FaDownload
                        onClick={() => window.open(documents.location.url)}
                        style={{
                          cursor: "pointer",
                          fontSize: "20px",
                          color: "blue",
                        }}
                      />
                    </ListGroup.Item>
                  )}

                  {documents.mgCrimRecord && (
                    <ListGroup.Item className="d-flex align-items-center justify-content-between">
                      <div className="d-flex align-items-center">
                        <FiFile style={{ marginRight: "5px" }} size={20} />
                        {documents.mgCrimRecord.name}
                      </div>
                      <FaDownload
                        onClick={() => window.open(documents.mgCrimRecord.url)}
                        style={{
                          cursor: "pointer",
                          fontSize: "20px",
                          color: "blue",
                        }}
                      />
                    </ListGroup.Item>
                  )}

                  {documents.verbalReport && (
                    <ListGroup.Item className="d-flex align-items-center justify-content-between">
                      <div className="d-flex align-items-center">
                        <FiFile style={{ marginRight: "5px" }} size={20} />
                        {documents.verbalReport.name}
                      </div>
                      <FaDownload
                        onClick={() => window.open(documents.verbalReport.url)}
                        style={{
                          cursor: "pointer",
                          fontSize: "20px",
                          color: "blue",
                        }}
                      />
                    </ListGroup.Item>
                  )}

                  {documents.assocStatutes && (
                    <ListGroup.Item className="d-flex align-items-center justify-content-between">
                      <div className="d-flex align-items-center">
                        <FiFile style={{ marginRight: "5px" }} size={20} />
                        {documents.assocStatutes.name}
                      </div>
                      <FaDownload
                        onClick={() => window.open(documents.assocStatutes.url)}
                        style={{
                          cursor: "pointer",
                          fontSize: "20px",
                          color: "blue",
                        }}
                      />
                    </ListGroup.Item>
                  )}

                  {documents.assocRules && (
                    <ListGroup.Item className="d-flex align-items-center justify-content-between">
                      <div className="d-flex align-items-center">
                        <FiFile style={{ marginRight: "5px" }} size={20} />
                        {documents.assocRules.name}
                      </div>
                      <FaDownload
                        onClick={() => window.open(documents.assocRules.url)}
                        style={{
                          cursor: "pointer",
                          fontSize: "20px",
                          color: "blue",
                        }}
                      />
                    </ListGroup.Item>
                  )}

                  {documents.assocAssemblyReport && (
                    <ListGroup.Item className="d-flex align-items-center justify-content-between">
                      <div className="d-flex align-items-center">
                        <FiFile style={{ marginRight: "5px" }} size={20} />
                        {documents.assocAssemblyReport.name}
                      </div>
                      <FaDownload
                        onClick={() =>
                          window.open(documents.assocAssemblyReport.url)
                        }
                        style={{
                          cursor: "pointer",
                          fontSize: "20px",
                          color: "blue",
                        }}
                      />
                    </ListGroup.Item>
                  )}

                  {documents.mgWedCert && (
                    <ListGroup.Item className="d-flex align-items-center justify-content-between">
                      <div className="d-flex align-items-center">
                        <FiFile style={{ marginRight: "5px" }} size={20} />
                        {documents.mgWedCert.name}
                      </div>
                      <FaDownload
                        onClick={() => window.open(documents.mgWedCert.url)}
                        style={{
                          cursor: "pointer",
                          fontSize: "20px",
                          color: "blue",
                        }}
                      />
                    </ListGroup.Item>
                  )}

                  {documents.capDepProof && (
                    <ListGroup.Item className="d-flex align-items-center justify-content-between">
                      <div className="d-flex align-items-center">
                        <FiFile style={{ marginRight: "5px" }} size={20} />
                        {documents.capDepProof.name}
                      </div>
                      <FaDownload
                        onClick={() => window.open(documents.capDepProof.url)}
                        style={{
                          cursor: "pointer",
                          fontSize: "20px",
                          color: "blue",
                        }}
                      />
                    </ListGroup.Item>
                  )}
                </ListGroup>
              )}

              {businessCreation?.comment && (
                <Row className="g-4 mt-2">
                  <Col>
                    <h6 className="fw-bold">Commentaire</h6>
                    <p className="mb-1">{businessCreation?.comment}</p>
                  </Col>
                </Row>
              )}
          </div>
        </>
      )}

      <Modal show={showModal} onHide={handleModalClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Commentaire</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              if (!formData.comment || !attachment) {
                Toast.fire({
                  icon: "error",
                  title: "Champs requis",
                  text: "La pièce jointe est obligatoire.",
                });
                return;
              }
              handleAction(action);
            }}
          >
            <Form.Group className="mb-3">
              <Form.Control
                as="textarea"
                name="comment"
                rows={3}
                value={formData.comment}
                onChange={(e) => setFormData({ comment: e.target.value })}
                placeholder="Ecrivez un commentaire..."
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Pièce jointe</Form.Label>
              <div className="d-flex flex-column align-items-start">
                <div>
                  <label
                    htmlFor="file-upload"
                    className="btn btn-outline-secondary"
                  >
                    <FaPaperclip /> Ajouter un fichier
                  </label>
                  <input
                    id="file-upload"
                    type="file"
                    className="d-none"
                    onChange={handleFileChange}
                  />
                </div>
                {attachment && (
                  <div className="mt-2">
                    <span>
                      {attachment.name}{" "}
                      <FaRegTimesCircle
                        onClick={() => setAttachment(null)}
                        style={{
                          cursor: "pointer",
                          fontSize: "20px",
                          color: "red",
                        }}
                      />
                    </span>
                  </div>
                )}
              </div>
            </Form.Group>

            <div className="text-end">
              <Button
                variant="secondary"
                onClick={handleModalClose}
                className="me-2"
              >
                Annuler
              </Button>
              <Button variant="primary" type="submit">
                Soumettre
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      <div style={{ display: "none" }}>
        <PrintCreationProcedure
          ref={contentRef}
          businessCreation={businessCreation}
        />
      </div>
    </>
  );
}

export default BusinessCreationDetails;
